exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-title-box[data-v-5eb4e91a] {\r\n  background: #fff;\r\n  height: 65px;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n          align-items: center;\n}\n.header-title[data-v-5eb4e91a] {\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  text-align:center;\n}\n.header-desc[data-v-5eb4e91a] {\r\n  color: #999;\r\n  font-size: 15px;\r\n  text-align:center;\n}\r\n\r\n", ""]);

// exports
